import {
  setupHoverRojo,
  loadJS,
  loadCSS,
  debounce,
  iOS,
} from "./modules/utils.js";
import { setupEncuesta } from "./modules/encuesta.js";
import { procesarImagenes } from "./modules/imagenes.js";
import { setupMenu } from "./modules/menu.js";
import { setupBuscador } from "./modules/buscador.js";
import { setupSingle } from "./modules/single.js";
import { setupTagSlider } from "./modules/tag_slider.js";
import {
  setupGalerias,
  setupRevistasSlider,
  setupGlightbox,
} from "./modules/galeria_fotos.js";
import { setupSuscripcion } from "./modules/suscripcion.js";
import { setupSeccion } from "./modules/seccion.js";
import { setupNoticiaEventos } from "./modules/noticia.js";
import { setupEbooks } from "./modules/ebooks.js";
import { setupTemaDelDia } from "./modules/temaDelDia.js";
import { setupCarousel } from "./modules/carousel.js";
import { contactFormScroll } from "./modules/clinica_single.js";
import { setupFiltros } from "./modules/filtros.js";
import { setupMapaFarmacias } from "./modules/mapa.js";
//import { setupModal } from "./modules/modal.js";

var tenia_scrolled;
window.ignorar_scrolled = false;
window.galeria_images_loaded = [];
window.isMobile =
  document.querySelector("body").clientWidth < 993 ? true : false;

function ready(fn) {
  if (document.readyState != "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
ready(page_ready);

function page_ready() {
  var html_el = document.querySelector("html");
  var body_el = document.querySelector("body");
  var header_el = document.querySelector("header");
  body_el.classList.add("loaded");

  //feature banner superior
  const ad_top = document.querySelector(".ad_top");
  if (ad_top) {
    body_el.classList.add("incluye_banner_superior");
  }

  var isiPad = navigator.userAgent.match(/iPad/i) != null;
  var isiPhone = navigator.userAgent.match(/iPhone/i) != null;
  if (isiPad) body_el.classList.add("ipad");
  if (isiPhone) body_el.classList.add("iphone");
  if (iOS()) body_el.classList.add("ios");

  //capturar error de imágenes + placeholder
  procesarImagenes();

  setupMenu();
  setupBuscador();
  setupTagSlider();
  setupSingle();
  setupGalerias();
  setupSuscripcion();
  setupSeccion();
  setupEncuesta();
  setupNoticiaEventos();
  setupEbooks();
  setupTemaDelDia();
  setupCarousel();
  contactFormScroll();
  setupGlightbox();
  setupFiltros();
  setupMapaFarmacias();
  // setupModal();

  function resizedw() {
    window.isMobile =
      document.querySelector("body").clientWidth < 993 ? true : false;
  }

  var doit;
  window.onresize = function () {
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  };

  //setear ancho scrollbar
  setTimeout(function () {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.offsetWidth;

    document.documentElement.style.setProperty(
      "--ancho-scrollbar",
      scrollbarWidth + "px"
    );
  }, 1000);
} //ready

// const nodos = document.querySelectorAll(".noticia__contenedor");
// nodos.forEach((element) => {
//   element.classList.add("destacada");
// });
